import { TransfersProduct } from "../model";
import { getLocalApi } from "./localApi";
import apiConfig from "app/api/apiConfig.json";
import { readIsUsedInActivePackage } from "./productDtoHelpers";

export async function getTransferProducts(divisionId: number) {
    const localApi = await getLocalApi();
    const endpoint = apiConfig.transfers_get_all.replace("{divisionId}", divisionId.toString());
    const noCacheUrl = `${endpoint}?_=${Date.now()}`;

    return await localApi.fetchList(
        noCacheUrl,
        mapTransferProducts,
        "Failed to fetch transfer products"
    );
}

function mapTransferProducts(transferProduct: any): TransfersProduct {
    return {
        id: transferProduct.productId,
        name: transferProduct.productName,
        lastModifiedDate: transferProduct.lastModifiedDate,
        lastUpdatedBy: transferProduct.lastModifiedBy,
        lastModifiedBy: transferProduct.lastModifiedBy,
        division: transferProduct.divisionId,
        divisionText:transferProduct.division,
        divisionId: transferProduct.divisionId,
        port: transferProduct.portId,
        portId: transferProduct.portId,
        portText: transferProduct.port,
        transferTypeText:transferProduct.transferTypeText,
        transferType: transferProduct.transferTypeId != null ? String(transferProduct.transferTypeId) : (transferProduct.transferType ?? ""),
        transferTypeId: transferProduct.transferTypeId,
        entityUpdate: transferProduct.entityUpdate,
        active: transferProduct.active,
        accountCategoryId: transferProduct.accountCategoryId,
        productCategoryId: transferProduct.productCategoryId,
        accountCategoryText: transferProduct.accountCategoryText,
        productCategoryText: transferProduct.productCategoryText,
        productId: transferProduct.productId,
        productName: transferProduct.productName,
        lastModifiedById: transferProduct.lastModifiedById,
        offeringClosureDate: transferProduct.offeringClosureDate,
        isLocked: transferProduct.isLocked ?? false,
        excludedBookingSystemIds: Array.isArray(transferProduct.excludedBookingSystemIds)
          ? transferProduct.excludedBookingSystemIds.map((id: number | string) => String(id))
          : [],
        isUsedInActivePackage: readIsUsedInActivePackage(transferProduct),
    }
}